import { render } from "./LeftBar.vue?vue&type=template&id=c64c29de&scoped=true"
import script from "./LeftBar.vue?vue&type=script&lang=js"
export * from "./LeftBar.vue?vue&type=script&lang=js"

import "./LeftBar.vue?vue&type=style&index=0&id=c64c29de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c64c29de"

export default script